import { snippetsBuilder } from '@/commons/components/monaco-editor/language/lang';

const snippets = [];
const add = snippetsBuilder(snippets).add;

export default Object.freeze(snippets);
